import React, { Fragment, useEffect, useState } from 'react';
import { DefaultQueryParams, parseQuery, useTranslation } from '@pascal/pascal-core';
import { useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { gameConfigStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
import {
  GAME_RULES_HELP_KEYS,
  GAME_RULES_HELP_KEYS_TURBO,
  TURBO_GAME_ID,
} from '../../enums/constants';
import helpImg1 from '../../assets/images/helps/help-1.png';
import helpImg2 from '../../assets/images/helps/help-2.png';
import helpImg3 from '../../assets/images/helps/help-3.png';
import helpImg4 from '../../assets/images/helps/help-4.png';
import helpImg5 from '../../assets/images/helps/help-5.png';
import turboHelpImg1 from '../../assets/images/helps/turbo-help-1.png';
import turboHelpImg2 from '../../assets/images/helps/turbo-help-2.png';
import turboHelpImg3 from '../../assets/images/helps/turbo-help-3.png';
import turboHelpImg4 from '../../assets/images/helps/turbo-help-4.png';
import turboHelpImg5 from '../../assets/images/helps/turbo-help-5.png';
import { limitsAndPayoutsStore } from '../../store/limitsAndPayoutsStore';
import { limitsTranslationKeys } from '../../enums/limitsTranslationKeys';

const sortedImages = {
  11: helpImg1,
  12: helpImg2,
  25: helpImg3,
  20: helpImg4,
  1: helpImg5,
};

const sortedTurboImages = {
  0: turboHelpImg1,
  13: turboHelpImg2,
  17: turboHelpImg3,
  22: turboHelpImg4,
  27: turboHelpImg5,
};

export const HelpPopup = observer(() => {
  const t = useTranslation();
  const { search } = useLocation();
  const [changedAdditionalLimits, setChangedAdditionalLimits] = useState(null);
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(search);
  const isTurbo = +gameId === TURBO_GAME_ID;
  const { limitsPayouts } = limitsAndPayoutsStore;
  const { limits: { additionalLimits } = {} } = gameConfigStore;
  const { currencySymbolOrCode } = userInfoStore;

  useEffect(() => {
    const newLimits = {};
    Object.keys(additionalLimits).forEach((key) => {
      newLimits[key.toLowerCase()] = additionalLimits[key];
    });

    setChangedAdditionalLimits(newLimits);
  }, [additionalLimits]);

  return (
    <>
      <div className='c-m-game-rules'>
        {isTurbo
          ? GAME_RULES_HELP_KEYS_TURBO.map((item) => (
              <Fragment key={item}>
                <p className='baccarat-modal-par'>{t(`TGAME_RULES_P${item + 1}`)}</p>
                {!!sortedTurboImages?.[item] && (
                  <div className='c-m-game-rules-img'>
                    <img src={sortedTurboImages?.[item]} alt='' />
                  </div>
                )}
              </Fragment>
            ))
          : GAME_RULES_HELP_KEYS.map((item) => (
              <Fragment key={item}>
                <p className='baccarat-modal-par'>{t(`GAME_RULES_P${item + 1}`)}</p>
                {!!sortedImages?.[item] && (
                  <div className='c-m-game-rules-img'>
                    <img src={sortedImages?.[item]} alt='' />
                  </div>
                )}
              </Fragment>
            ))}
        <p className='baccarat-modal-par'>{t('CANCELATION_MESSAGE_1')}</p>
        <p className='baccarat-modal-par'>{t('MALFUNCTION_MESSAGE_2')}</p>
        <p className='baccarat-modal-par'>{t('STATITSTICS')}</p>
      </div>

      <div className='baccarat-rules-container'>
        <div className='baccarat-first-two-cards-table'>
          <div className='baccarat-first-two-cards-table-head'>
            <span className='baccarat-first-two-cards-table-text'>
              {isTurbo ? t('GAME_RULES_P46') : t('GAME_RULES_P29')}
            </span>
          </div>
          <div className='baccarat-first-two-cards-table-row'>
            <div className='baccarat-first-two-cards-table-column'>
              <span className='baccarat-first-two-cards-table-text'>0-1-2-3-4-5</span>
            </div>
            <div className='baccarat-first-two-cards-table-column'>
              <span className='baccarat-first-two-cards-table-text'>{t('GAME_RULES_P30')}</span>
            </div>
          </div>
          <div className='baccarat-first-two-cards-table-row'>
            <div className='baccarat-first-two-cards-table-column'>
              <span className='baccarat-first-two-cards-table-text'>6-7</span>
            </div>
            <div className='baccarat-first-two-cards-table-column'>
              <span className='baccarat-first-two-cards-table-text'>{t('GAME_RULES_P31')}</span>
            </div>
          </div>
          <div className='baccarat-first-two-cards-table-row'>
            <div className='baccarat-first-two-cards-table-column'>
              <span className='baccarat-first-two-cards-table-text'>8-9</span>
            </div>
            <div className='baccarat-first-two-cards-table-column'>
              <span className='baccarat-first-two-cards-table-text'>{t('GAME_RULES_P32')}</span>
            </div>
          </div>
        </div>
        <br />
        <div className='baccarat-rules-table-container'>
          <div className='baccarat-rules-table'>
            <div className='baccarat-rules-table-head'>
              <div className='baccarat-rules-table-head-column'>
                <span className='baccarat-rules-table-text'>{t('GAME_RULES_P34')}</span>
              </div>
              <div className='baccarat-rules-table-head-column'>
                <span className='baccarat-rules-table-text'>{t('GAME_RULES_P35')}</span>
              </div>
              <div className='baccarat-rules-table-head-row'>
                <div className='baccarat-rules-table-head-row-title'>
                  <span className='baccarat-rules-table-text'>{t('GAME_RULES_P36')}</span>
                </div>
                <div className='baccarat-rules-table-head-row-inner'>
                  <div className='baccarat-rules-table-head-row-column'>
                    <span className='baccarat-rules-table-text'>0</span>
                  </div>
                  <div className='baccarat-rules-table-head-row-column'>
                    <span className='baccarat-rules-table-text'>1</span>
                  </div>
                  <div className='baccarat-rules-table-head-row-column'>
                    <span className='baccarat-rules-table-text'>2</span>
                  </div>
                  <div className='baccarat-rules-table-head-row-column'>
                    <span className='baccarat-rules-table-text'>3</span>
                  </div>
                  <div className='baccarat-rules-table-head-row-column'>
                    <span className='baccarat-rules-table-text'>4</span>
                  </div>
                  <div className='baccarat-rules-table-head-row-column'>
                    <span className='baccarat-rules-table-text'>5</span>
                  </div>
                  <div className='baccarat-rules-table-head-row-column'>
                    <span className='baccarat-rules-table-text'>6</span>
                  </div>
                  <div className='baccarat-rules-table-head-row-column'>
                    <span className='baccarat-rules-table-text'>7</span>
                  </div>
                  <div className='baccarat-rules-table-head-row-column'>
                    <span className='baccarat-rules-table-text'>8</span>
                  </div>
                  <div className='baccarat-rules-table-head-row-column'>
                    <span className='baccarat-rules-table-text'>9</span>
                  </div>
                </div>
              </div>
            </div>
            <div className='baccarat-rules-table-row'>
              <div className='baccarat-rules-table-column auto'>
                <span className='baccarat-rules-table-text'>0</span>
              </div>
              <div className='baccarat-rules-table-column auto'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
            </div>
            <div className='baccarat-rules-table-row'>
              <div className='baccarat-rules-table-column auto'>
                <span className='baccarat-rules-table-text'>1</span>
              </div>
              <div className='baccarat-rules-table-column auto'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
            </div>
            <div className='baccarat-rules-table-row'>
              <div className='baccarat-rules-table-column auto'>
                <span className='baccarat-rules-table-text'>2</span>
              </div>
              <div className='baccarat-rules-table-column auto'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
            </div>
            <div className='baccarat-rules-table-row'>
              <div className='baccarat-rules-table-column auto'>
                <span className='baccarat-rules-table-text'>3</span>
              </div>
              <div className='baccarat-rules-table-column auto'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
            </div>
            <div className='baccarat-rules-table-row'>
              <div className='baccarat-rules-table-column auto'>
                <span className='baccarat-rules-table-text'>4</span>
              </div>
              <div className='baccarat-rules-table-column auto'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
            </div>
            <div className='baccarat-rules-table-row'>
              <div className='baccarat-rules-table-column auto'>
                <span className='baccarat-rules-table-text'>5</span>
              </div>
              <div className='baccarat-rules-table-column auto'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
            </div>
            <div className='baccarat-rules-table-row'>
              <div className='baccarat-rules-table-column auto'>
                <span className='baccarat-rules-table-text'>6</span>
              </div>
              <div className='baccarat-rules-table-column auto'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>d</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
            </div>
            <div className='baccarat-rules-table-row'>
              <div className='baccarat-rules-table-column auto'>
                <span className='baccarat-rules-table-text'>7</span>
              </div>
              <div className='baccarat-rules-table-column auto'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
            </div>
            <div className='baccarat-rules-table-row'>
              <div className='baccarat-rules-table-column auto'>
                <span className='baccarat-rules-table-text'>8</span>
              </div>
              <div className='baccarat-rules-table-column auto'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
            </div>
            <div className='baccarat-rules-table-row'>
              <div className='baccarat-rules-table-column auto'>
                <span className='baccarat-rules-table-text'>9</span>
              </div>
              <div className='baccarat-rules-table-column auto'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
              <div className='baccarat-rules-table-column'>
                <span className='baccarat-rules-table-text'>s</span>
              </div>
            </div>
          </div>
          <p className='baccarat-rules-bottom-text'>
            D-{t('DRAW')}, S-{t('STAND')}
          </p>
        </div>
        <div className='baccarat-bet-and-winning-table'>
          <div className='baccarat-bet-and-winning-table-row head'>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>{t('GAME_RULES_P38')}</span>
            </div>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>{t('GAME_RULES_P44')}</span>
            </div>
          </div>
          <div className='baccarat-bet-and-winning-table-row'>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>{t('GAME_RULES_P39')}</span>
            </div>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>x2</span>
            </div>
          </div>
          <div className='baccarat-bet-and-winning-table-row'>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>{t('GAME_RULES_P40')}</span>
            </div>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>x1.95</span>
            </div>
          </div>
          <div className='baccarat-bet-and-winning-table-row'>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>{t('GAME_RULES_P41')}</span>
            </div>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>x9</span>
            </div>
          </div>
          <div className='baccarat-bet-and-winning-table-row'>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>{t('GAME_RULES_P42')}</span>
            </div>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>x12</span>
            </div>
          </div>
          <div className='baccarat-bet-and-winning-table-row'>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>{t('GAME_RULES_P43')}</span>
            </div>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>x12</span>
            </div>
          </div>
        </div>

        <p className='baccarat-rules-bottom-text'>{t('LIMITS_AND_PAYOUTS')}</p>
        <div className='baccarat-bet-and-winning-table'>
          <div className='baccarat-bet-and-winning-table-row head'>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>{t('BET')}</span>
            </div>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>{t('MAX_WIN')}</span>
            </div>
          </div>
          {limitsPayouts.map(({ marketType }) => {
            return (
              <div className='baccarat-bet-and-winning-table-row' key={marketType}>
                <div className='baccarat-bet-and-winning-table-column'>
                  <span className='baccarat-bet-and-winning-table-text'>
                    {t(limitsTranslationKeys[marketType])}
                  </span>
                </div>
                <div className='baccarat-bet-and-winning-table-column'>
                  <span className='baccarat-bet-and-winning-table-text'>
                    {currencySymbolOrCode}{' '}
                    {changedAdditionalLimits &&
                      changedAdditionalLimits[marketType.toLowerCase()].maxWin}
                  </span>
                </div>
              </div>
            );
          })}
        </div>

        <p className='baccarat-rules-bottom-text'>{t('RTP')}</p>
        <div className='baccarat-bet-and-winning-table'>
          <div className='baccarat-bet-and-winning-table-row head'>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>{t('MARKET')}</span>
            </div>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>{t('RTP')}</span>
            </div>
          </div>
          <div className='baccarat-bet-and-winning-table-row'>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>{t('GAME_RULES_P39')}</span>
            </div>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>98.76%</span>
            </div>
          </div>
          <div className='baccarat-bet-and-winning-table-row'>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>{t('GAME_RULES_P40')}</span>
            </div>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>98.94%</span>
            </div>
          </div>
          <div className='baccarat-bet-and-winning-table-row'>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>{t('GAME_RULES_P41')}</span>
            </div>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>85.64%</span>
            </div>
          </div>
          <div className='baccarat-bet-and-winning-table-row'>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>{t('GAME_RULES_P42')}</span>
            </div>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>89.64%</span>
            </div>
          </div>
          <div className='baccarat-bet-and-winning-table-row'>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>{t('GAME_RULES_P43')}</span>
            </div>
            <div className='baccarat-bet-and-winning-table-column'>
              <span className='baccarat-bet-and-winning-table-text'>89.64%</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});
